import React from 'react';
import koruLogoUrl from '../koru-logo.svg';

interface KoruLogoProps {
  size?: number;
  className?: string;
}

const KoruLogo: React.FC<KoruLogoProps> = ({ size = 32, className = '' }) => (
  <img src={koruLogoUrl} width={size} height={size} alt="Koru" className={className} />
);

export default KoruLogo;
